import 'jquery-nice-select';
import Cookies from 'js-cookie';
import { breakpoints } from '../components/breakpoints';
import { contactEvent, newsletterEvent, unitEvent } from '../components/google-analytics';

export default function form() {
  /**
   * On document ready, let AF make its thing first
   */
  $(document).ready(function () {
    /**
     * Disable ACF popup
     */
    if (typeof acf !== 'undefined') {
      acf.unload.active = false;
    }

    /**
     * Confirmation modal
     */
    const $modal = $('.form__modal');
    $modal.on('show.bs.modal', function () {
      $('#modal-newsletter').modal('hide');
      $('body').addClass('modal-open--form-confirmation');
    });
    $modal.on('hidden.bs.modal', function () {
      $('body').removeClass('modal-open--form-confirmation');
    });
    $modal.on('click', ".modal-body a[href='#']", function (e) {
      e.preventDefault();
      $modal.modal('hide');
    });

    $('.block.form').each(function () {
      const $block = $(this);

      //Move description at the end
      if ($block.find('.af-description').length) {
        $block.find('.af-submit').before($block.find('.af-description'));
      }

      const emptyForm = $block.find('.af-form').clone().wrap('<p/>').parent().html();

      function resetForm() {
        $block.find('.form__form').html(emptyForm);
        acf.doAction('append', $block);
        af.setup_form($block.find('.af-form'));
        init_form();
      }

      function init_form() {
        //Ajax submit form
        const $form = $block.find('.af-form');
        const key = $form.attr('data-key');
        const form = af.forms[key];

        form.submissionSteps = [];

        //Add submission step at very end, ajax handling
        af.addSubmissionStep(form, 100, function (callback) {
          acf.validation.lockForm(form.$el);

          // Don't call callback. The high priority makes sure AJAX is the last step to run.
          // By not calling the callback, the standard form submission won't happen.

          $form.find('.acf-spinner').addClass('visible');
          $form.find('.af-submit-button').addClass('disabled');

          const formData = new FormData($form.get(0));

          //Submit form to create entry
          $.ajax({
            url: $form.attr('action'),
            method: 'post',
            data: formData,
            processData: false,
            contentType: false,
            success: function (result) {
              //Submit form to create ADNETIS and Hubspot entries
              $.ajax({
                url: wordpress.ajaxurl,
                method: 'post',
                data: {
                  action: 'sage_advanced_form',
                  post_id: wordpress.post_id,
                  lang: wordpress.lang,
                  form: $form.serialize(),
                  hubspot_cookie: Cookies.get('hubspotutk'),
                },
                success: function (result) {
                  $modal.find('.modal-body').html(result);
                  $modal.modal('show');

                  //Trigger GTM events
                  if ($form.attr('id') === wordpress.forms.newsletter) {
                    newsletterEvent(formData);
                  } else if ($form.attr('id') === wordpress.forms.contact) {
                    contactEvent(formData);
                  } else if ($form.attr('id') === wordpress.forms.unit) {
                    unitEvent(formData);
                  }

                  resetForm();
                },
                error: function (error) {
                  $modal.find('.modal-body').html(wordpress.formerror);
                  $modal.modal('show');
                  resetForm();
                },
              });
            },
            error: function (error) {
              $modal.find('.modal-body').html(wordpress.formerror);
              $modal.modal('show');
              resetForm();
            },
          });
        });
      }

      init_form();
    });
  });
}
